<template>
  <svg fill="#000000" height="26" width="26" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
       viewBox="0 0 512 512" xml:space="preserve">
<g transform="translate(1 1)">
	<g>
		<g>
			<path d="M485.4-1H109.933c-14.507,0-25.6,11.093-25.6,25.6v25.6H24.6C10.093,50.2-1,61.293-1,75.8v409.6
				c0,14.507,11.093,25.6,25.6,25.6h324.267c14.507,0,25.6-11.093,25.6-25.6v-384c0-18.773,15.36-34.133,34.133-34.133
				c18.773,0,34.133,15.36,34.133,34.133v298.667c0,18.773,15.36,34.133,34.133,34.133c18.773,0,34.133-15.36,34.133-34.133V24.6
				C511,10.093,499.907-1,485.4-1z M357.4,101.4v384c0,5.12-3.413,8.533-8.533,8.533H24.6c-5.12,0-8.533-3.413-8.533-8.533V75.8
				c0-5.12,3.413-8.533,8.533-8.533h68.267H370.2C362.52,76.653,357.4,88.6,357.4,101.4z M493.933,400.067
				c0,9.387-7.68,17.067-17.067,17.067s-17.067-7.68-17.067-17.067V101.4c0-28.16-23.04-51.2-51.2-51.2H101.4V24.6
				c0-5.12,3.413-8.533,8.533-8.533H485.4c5.12,0,8.533,3.413,8.533,8.533V400.067z"/>
      <path d="M408.6,92.867c-5.12,0-8.533,3.413-8.533,8.533v375.467c0,5.12,3.413,8.533,8.533,8.533s8.533-3.413,8.533-8.533V101.4
				C417.133,96.28,413.72,92.867,408.6,92.867z"/>
      <path d="M41.667,101.4v170.667c0,5.12,3.413,8.533,8.533,8.533h68.267H255h68.267c5.12,0,8.533-3.413,8.533-8.533V101.4
				c0-5.12-3.413-8.533-8.533-8.533H50.2C45.08,92.867,41.667,96.28,41.667,101.4z M131.267,263.533
				c11.093-20.48,32.427-34.133,55.467-34.133c23.04,0,44.373,13.653,55.467,34.133H131.267z M152.6,178.2
				c0-18.773,15.36-34.133,34.133-34.133c18.773,0,34.133,15.36,34.133,34.133s-15.36,34.133-34.133,34.133
				C167.96,212.333,152.6,196.973,152.6,178.2z M58.733,109.933h256v153.6h-54.245c-8.334-20.422-23.914-36.255-42.819-44.617
				c12.291-9.374,20.264-24.157,20.264-40.716c0-28.16-23.04-51.2-51.2-51.2s-51.2,23.04-51.2,51.2
				c0,16.56,7.973,31.342,20.264,40.716c-18.905,8.361-34.485,24.195-42.819,44.617H58.733V109.933z"/>
      <path d="M169.667,306.2H50.2c-5.12,0-8.533,3.413-8.533,8.533s3.413,8.533,8.533,8.533h119.467c5.12,0,8.533-3.413,8.533-8.533
				S174.787,306.2,169.667,306.2z"/>
      <path d="M169.667,348.867H50.2c-5.12,0-8.533,3.413-8.533,8.533s3.413,8.533,8.533,8.533h119.467c5.12,0,8.533-3.413,8.533-8.533
				S174.787,348.867,169.667,348.867z"/>
      <path d="M323.267,348.867h-102.4c-5.12,0-8.533,3.413-8.533,8.533s3.413,8.533,8.533,8.533h102.4c5.12,0,8.533-3.413,8.533-8.533
				S328.387,348.867,323.267,348.867z"/>
      <path d="M323.267,306.2h-102.4c-5.12,0-8.533,3.413-8.533,8.533s3.413,8.533,8.533,8.533h102.4c5.12,0,8.533-3.413,8.533-8.533
				S328.387,306.2,323.267,306.2z"/>
      <path d="M169.667,391.533H50.2c-5.12,0-8.533,3.413-8.533,8.533c0,5.12,3.413,8.533,8.533,8.533h119.467
				c5.12,0,8.533-3.413,8.533-8.533C178.2,394.947,174.787,391.533,169.667,391.533z"/>
      <path d="M323.267,391.533h-102.4c-5.12,0-8.533,3.413-8.533,8.533c0,5.12,3.413,8.533,8.533,8.533h102.4
				c5.12,0,8.533-3.413,8.533-8.533C331.8,394.947,328.387,391.533,323.267,391.533z"/>
      <path d="M169.667,434.2H50.2c-5.12,0-8.533,3.413-8.533,8.533s3.413,8.533,8.533,8.533h119.467c5.12,0,8.533-3.413,8.533-8.533
				S174.787,434.2,169.667,434.2z"/>
      <path d="M323.267,434.2h-102.4c-5.12,0-8.533,3.413-8.533,8.533s3.413,8.533,8.533,8.533h102.4c5.12,0,8.533-3.413,8.533-8.533
				S328.387,434.2,323.267,434.2z"/>
		</g>
	</g>
</g>
</svg>
</template>
